/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EditorMode } from '../components/Editor';
import { useAppSelector } from '../app/hooks';

interface IdeSettingsSliceState {
  editorMode: EditorMode;
}

const initialState: IdeSettingsSliceState = {
  editorMode: EditorMode.Regular,
};

const ideSettingsSlice = createSlice({
  name: 'ideSettings',
  initialState,
  reducers: {
    setEditorMode(state, action: PayloadAction<EditorMode>) {
      state.editorMode = action.payload;
    },
  },
});

export default ideSettingsSlice.reducer;

export const useEditorMode = () =>
  useAppSelector((state) => state.ideSettings.editorMode);
